// eslint-disable-next-line import/no-anonymous-default-export
export default {
    bg: {
        default: '#FFFFFF',
        workspace: 'rgba(251, 255, 251, 1)',
        mainGreen: "rgba(98, 147, 97, 1)",
        grey: "#E7EFE7",

    },
    text: {
        primary: '#3A3A3A',
        mainGreen: 'rgba(98, 147, 97, 1)',
        secondaryGreen: 'rgba(149, 197, 157, 1)',
    },
    color: {
        default: '#FFFFFF',
        lightGreen: 'rgba(124, 190, 123, 1)',
        addingGreen: 'rgba(236, 247, 238, 1)',
        historyTableHeader: 'rgba(98, 147, 97, 0.15)',
        settingsBackground: '#629361',
        splitPanel: '#7CBE7B',
        scrollThumb: '#FFA620',
        placeholder: 'rgba(0, 0, 0, 0.38)'
    }
};
